export default {
    config: {
        defaultWidth: 80
    },
    default: {
        label: 'Est. Value'
    },
    unique: [],
    sort: 'worth.value',
    lang: {
        name: 'Estimated Worth',
        category: 'Game',
        description: 'The estimated value of the game based on online sales.',
        views: ['list', 'sheet', 'grid'],
    },
    filters: ['worth']
}